document.querySelectorAll('.mfb-support__copy').forEach(copy => {
  const privacy = copy.closest('[data-page="data-sharing-opt-out"]');
  const nav = copy.closest('.mfb-support').querySelector('.mfb-support__toc nav');
  nav.replaceChildren();
  if (!privacy) {
    copy.querySelectorAll('[class],[style]').forEach(el => {el.removeAttribute('class');el.removeAttribute('style');});
    copy.querySelectorAll('h1,h2,h3,h4,h5,h6').forEach((el,index) => {
      if(!el.textContent.trim()){el.remove();return;}
      const h=document.createElement('h2'); h.innerHTML=el.innerHTML; h.id='chapter-'+(index+1); h.tabIndex=-1; el.replaceWith(h);
      const a=document.createElement('a');a.href='#'+h.id;a.textContent=h.textContent;nav.append(a);
    });
  } else {
    const form=copy.querySelector('#pc--optOutFormContainer');
    if(form){const h=document.createElement('h2');h.id='privacy-options';h.tabIndex=-1;h.textContent='Your data-sharing choices';form.before(h);const a=document.createElement('a');a.href='#privacy-options';a.textContent=h.textContent;nav.append(a);}
  }
});
document.querySelectorAll('.mfb-support').forEach(root => {
  const toc = root.querySelector('.mfb-support__toc');
  const narrow = matchMedia('(max-width: 900px)');
  toc.open = !narrow.matches;
  narrow.addEventListener('change', () => { toc.open = !narrow.matches; });
  const anchors = [...root.querySelectorAll('.mfb-support__toc a')];
  const updateCurrent = () => anchors.forEach(a => {
    if (a.hash === location.hash) a.setAttribute('aria-current', 'location');
    else a.removeAttribute('aria-current');
  });
  root.querySelectorAll('a[href^="#"]').forEach(anchor => anchor.addEventListener('click', () => {
    const target = root.querySelector(anchor.hash);
    if (target?.hasAttribute('tabindex')) target.focus({ preventScroll: true });
  }));
  addEventListener('hashchange', updateCurrent);
  updateCurrent();
  const checkbox = root.querySelector('#preview-account-choice');
  if (checkbox) checkbox.addEventListener('change', () => {
    root.querySelector('#preview-email-field').hidden = !checkbox.checked;
    checkbox.setAttribute('aria-expanded', String(checkbox.checked));
  });
});
